module.exports = __webpack_public_path__ + "static/media/feedback.5e13c4a3.png";